import styled from 'styled-components';

export default styled.div`
  .params-icon-wrap {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fafafa;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .Mui-disabled {
    color: #ccc !important;
  }

  .css-123nw5d-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {
    border: 1px solid #ccc;
  }
  label.css-1g02fr1-MuiFormLabel-root-MuiInputLabel-root {
    padding-left: 8px;
    padding-right: 10px;
    background: #fff;
  }
  .file_name {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    background-color: ${(props) =>
      props.queryType === 'detail' ? '#fff' : '#e0e0e0'};
    border-radius: 16px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .qr-wrap {
    .button-wrap {
      .Mui-disabled {
        background-color: #ccc;
        color: #fff !important;
      }
    }
  }
`;
